import { html, unsafeCSS, CSSResultGroup } from "lit";
import { customElement, property } from "lit/decorators.js";
import informationBlockStyles from "../../styles/information-block.css?inline";
import { Icon } from "../Icon";
import { ApidaeVisualHost } from "../ApidaeVisualHost";

// Import nécessaire pour enregistrer le composant Icon
Icon;

interface InformationItem {
  icon: string;
  title: string;
  content: string;
  url?: string;
}

@customElement("apidae-detail-view-information-block-listing")
export class InformationBlockListing extends ApidaeVisualHost {
  static styles: CSSResultGroup = unsafeCSS(informationBlockStyles);

  @property({ type: Array })
  items: InformationItem[] = [];

  render() {
    if (!this.items || this.items.length === 0) {
      return html``;
    }

    return html`
      <div class="information-block-listing-container">
        ${this.items.map(
          (item) => html`
            <div class="information-block-listing">
              <div class="information-block-listing-header">
                ${item.icon
                  ? html`
                      <apidae-icon
                        name="${item.icon}"
                        size="20"
                        color="currentColor"
                        .visualCustomization=${this.visualCustomization}
                      ></apidae-icon>
                    `
                  : ""}
                ${item.title ? html`<span>${item.title}</span>` : ""}
              </div>
              <div class="information-block-listing-content">
                ${item.url
                  ? html`<a
                      class="information-block-listing-link"
                      href="${item.url}"
                      target="${item.url.startsWith("mailto:") ||
                      item.url.startsWith("tel:")
                        ? "_self"
                        : "_blank"}"
                      rel="noopener noreferrer"
                      >${item.content}</a
                    >`
                  : html`<span>${item.content}</span>`}
              </div>
            </div>
          `,
        )}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "apidae-detail-view-information-block-listing": InformationBlockListing;
  }
}
